import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import { useTheme } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import useMediaQuery from "@mui/material/useMediaQuery";

const useStyles = makeStyles(() => ({
  formHeaderContainer: {
    borderRadius: 4,
    backgroundColor: "#cfe8fd",
    border: "1px solid rgba(0, 0, 0, .125)",
    padding: "5px 0px",
    height: 50,
  },
  fontFormat: {
    fontSize: "0.75em",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  resetButton: {
    backgroundColor: "#d1495b",
    minWidth: 100,
    "&:hover": {
      backgroundColor: "#b82f41",
    },
  },
}));

function FormHeader({ formName, vehicleInfo, save, cancel, submitting }) {
  const classes = useStyles();
  const { t } = useTranslation();
  const theme = useTheme();
  const isXtraSmall = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Grid
      container
      direction="row"
      alignItems="center"
      className={classes.formHeaderContainer}
    >
      <Grid
        item
        xs={isXtraSmall ? 0 : vehicleInfo.length === 0 ? 6 : 4}
        style={{
          display: isXtraSmall ? "none" : "flex",
          justifyContent: "center",
          overflow: "hidden",
        }}
      >
        <b>{t("documents.form")}: </b> &nbsp; {formName}
      </Grid>
      {vehicleInfo !== undefined && vehicleInfo !== "" ? (
        <Grid
          item
          xs={isXtraSmall ? 0 : 4}
          style={{
            display: isXtraSmall ? "none" : "flex",
            justifyContent: "center",
            overflow: "hidden",
          }}
        >
          <b>{t("documents.vehicle")}: </b> &nbsp; {vehicleInfo}
        </Grid>
      ) : (
        <></>
      )}
      <Grid item xs={isXtraSmall ? 12 : vehicleInfo.length === 0 ? 6 : 4}>
        <Grid
          container
          direction="row"
          alignItems="center"
          justifyContent="center"
          style={{ textAlign: isXtraSmall ? "center" : "inherit" }}
        >
          <Grid item xs={6}>
            <Button
              size="medium"
              variant="contained"
              disabled={submitting}
              color="primary"
              style={{ minWidth: 100 }}
              onClick={() => save()}
            >
              {t("buttons.saveButton")}
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button
              size="medium"
              variant="contained"
              disabled={submitting}
              className={classes.resetButton}
              onClick={() => cancel()}
            >
              {t("buttons.cancelButton")}
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

FormHeader.propTypes = {
  formName: PropTypes.string.isRequired,
  vehicleInfo: PropTypes.string,
  save: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
};

export default FormHeader;
